import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function updateAdminUser(id, { role, permission, user_create_limit }) {
  try {
    const path = `${BACKEND_URL}/admin/update_user/${id}`;

    const res = await authFetch(path, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ role, permission, user_create_limit }),
    });

    const result = await res.json().catch(() => null);

    if (!result) {
      return {
        success: false,
        ...normalizeApiMessage(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
        ),
        messageKey: "api.common.serverError",
      };
    }

    if (!res.ok || result?.success !== true) {
      return {
        success: false,
        ...normalizeApiMessage(result, "Failed to update user."),
      };
    }

    return {
      success: true,
      ...normalizeApiMessage(result, "User updated successfully."),
    };
  } catch (err) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: err?.message || "Network error" },
        err?.message || "Network error",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
